import React__default from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import sx from '../../sx.js';
import { AkRbActionIcon, AkRbAssignIcon, AkRbAttachmentIcon, AkRbBugIcon, AkRbCalendarIcon, AkRbCommentIcon, AkRbConnectionIcon, AkRbDeprecatedIcon, AkRbEpicIcon, AkRbErrorIcon, AkRbFieldIcon, AkRbFiltersIcon, AkRbHierarchyIcon, AkRbIssueIcon, AkRbLinkIcon, AkRbMailIcon, AkRbMessageIcon, AkRbMiscIcon, AkRbOtherIcon, AkRbParentIcon, AkRbProjectIcon, AkRbScreenIcon, AkRbScriptIcon, AkRbSettingsIcon, AkRbSharedIcon, AkRbSiblingIcon, AkRbStatusIcon, AkRbStoryIcon, AkRbSubtaskIcon, AkRbSyncIcon, AkRbTaskIcon, AkRbTimeIcon, AkRbTemplateIcon, AkRbTriggerIcon, AkRbTypeIcon, AkRbUserIcon, AkRbUsersIcon, AkRbWorklogIcon, AkRbWorkflowIcon } from '@fuegokit/fuegoicons-react';
import Box from '../Box/Box.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ruleBuilderIconsMap = {
  action: AkRbActionIcon,
  assign: AkRbAssignIcon,
  attachment: AkRbAttachmentIcon,
  bug: AkRbBugIcon,
  calendar: AkRbCalendarIcon,
  comment: AkRbCommentIcon,
  connection: AkRbConnectionIcon,
  deprecated: AkRbDeprecatedIcon,
  epic: AkRbEpicIcon,
  error: AkRbErrorIcon,
  field: AkRbFieldIcon,
  filters: AkRbFiltersIcon,
  hierarchy: AkRbHierarchyIcon,
  issue: AkRbIssueIcon,
  link: AkRbLinkIcon,
  mail: AkRbMailIcon,
  message: AkRbMessageIcon,
  misc: AkRbMiscIcon,
  other: AkRbOtherIcon,
  parent: AkRbParentIcon,
  project: AkRbProjectIcon,
  screen: AkRbScreenIcon,
  script: AkRbScriptIcon,
  settings: AkRbSettingsIcon,
  shared: AkRbSharedIcon,
  sibling: AkRbSiblingIcon,
  status: AkRbStatusIcon,
  story: AkRbStoryIcon,
  subtask: AkRbSubtaskIcon,
  sync: AkRbSyncIcon,
  task: AkRbTaskIcon,
  time: AkRbTimeIcon,
  template: AkRbTemplateIcon,
  trigger: AkRbTriggerIcon,
  type: AkRbTypeIcon,
  user: AkRbUserIcon,
  users: AkRbUsersIcon,
  worklog: AkRbWorklogIcon,
  workflow: AkRbWorkflowIcon
};
const ruleBuilderWrapperAppearanceObject = {
  bold: {
    action: 'colors.background.accent.purple.bolder',
    assign: 'colors.background.accent.yellow.bolder',
    attachment: 'colors.background.accent.magenta.bolder',
    bug: 'colors.background.accent.red.bolder',
    calendar: 'colors.background.accent.orange.bolder',
    comment: 'colors.background.accent.green.bolder',
    connection: 'colors.background.accent.teal.bolder',
    deprecated: 'colors.background.accent.red.bolder',
    epic: 'colors.background.accent.purple.bolder',
    error: 'colors.background.accent.red.bolder',
    field: 'colors.background.accent.teal.bolder',
    filters: 'colors.background.accent.green.bolder',
    hierarchy: 'colors.background.accent.orange.bolder',
    issue: 'colors.background.accent.blue.bolder',
    link: 'colors.background.accent.magenta.bolder',
    mail: 'colors.background.accent.purple.bolder',
    message: 'colors.background.accent.teal.bolder',
    misc: 'colors.background.accent.teal.bolder',
    other: 'colors.background.accent.gray.bolder',
    parent: 'colors.background.accent.blue.bolder',
    project: 'colors.background.accent.purple.bolder',
    screen: 'colors.background.accent.teal.bolder',
    script: 'colors.background.accent.purple.bolder',
    shared: 'colors.background.accent.orange.bolder',
    settings: 'colors.background.accent.orange.bolder',
    sibling: 'colors.background.accent.blue.bolder',
    status: 'colors.background.accent.green.bolder',
    story: 'colors.background.accent.green.bolder',
    subtask: 'colors.background.accent.blue.bolder',
    sync: 'colors.background.accent.green.bolder',
    task: 'colors.background.accent.blue.bolder',
    template: 'colors.background.accent.purple.bolder',
    time: 'colors.background.accent.orange.bolder',
    trigger: 'colors.background.accent.red.bolder',
    type: 'colors.background.accent.blue.bolder',
    user: 'colors.background.accent.yellow.bolder',
    users: 'colors.background.accent.green.bolder',
    worklog: 'colors.background.accent.orange.bolder',
    workflow: 'colors.background.accent.purple.bolder'
  },
  default: {
    action: 'colors.background.accent.purple.subtle',
    assign: 'colors.background.accent.yellow.subtle',
    attachment: 'colors.background.accent.magenta.subtle',
    bug: 'colors.background.accent.red.subtle',
    calendar: 'colors.background.accent.orange.subtle',
    comment: 'colors.background.accent.green.subtle',
    connection: 'colors.background.accent.teal.subtle',
    deprecated: 'colors.background.accent.red.subtle',
    epic: 'colors.background.accent.purple.subtle',
    error: 'colors.background.accent.red.subtle',
    field: 'colors.background.accent.teal.subtle',
    filters: 'colors.background.accent.green.subtle',
    hierarchy: 'colors.background.accent.orange.subtle',
    issue: 'colors.background.accent.blue.subtle',
    link: 'colors.background.accent.magenta.subtle',
    mail: 'colors.background.accent.purple.subtle',
    message: 'colors.background.accent.teal.subtle',
    misc: 'colors.background.accent.teal.subtle',
    other: 'colors.background.accent.gray.subtle',
    parent: 'colors.background.accent.blue.subtle',
    project: 'colors.background.accent.purple.subtle',
    screen: 'colors.background.accent.teal.subtle',
    script: 'colors.background.accent.purple.subtle',
    settings: 'colors.background.accent.orange.subtle',
    shared: 'colors.background.accent.orange.subtle',
    sibling: 'colors.background.accent.blue.subtle',
    status: 'colors.background.accent.green.subtle',
    story: 'colors.background.accent.green.subtle',
    subtask: 'colors.background.accent.blue.subtle',
    sync: 'colors.background.accent.green.subtle',
    task: 'colors.background.accent.blue.subtle',
    template: 'colors.background.accent.purple.subtle',
    time: 'colors.background.accent.orange.subtle',
    trigger: 'colors.background.accent.red.subtle',
    type: 'colors.background.accent.blue.subtle',
    user: 'colors.background.accent.yellow.subtle',
    users: 'colors.background.accent.green.subtle',
    worklog: 'colors.background.accent.orange.subtle',
    workflow: 'colors.background.accent.purple.subtle'
  }
};
const paddingObject = {
  small: `3px 4px`,
  default: `0px 0px`,
  medium: `0px 0px`,
  large: `0px 0px`
};
const sizeObject = {
  small: 16,
  default: 24,
  medium: 32,
  large: 48
};
const Wrapper = styled(Box).withConfig({
  displayName: "RuleBuilderIcon__Wrapper",
  componentId: "sc-1avm9f3-0"
})(["display:inline-flex;border-radius:", ";padding:", ";background-color:", ";color:", ";", ""], p => p.size === 'small' ? themeGet('radii.1') : themeGet('radii.2'), p => p.size ? paddingObject[p.size] : '0', p => {
  if (p.isDisabled) {
    return themeGet('colors.background.disabled');
  }
  return p.isBold ? themeGet(ruleBuilderWrapperAppearanceObject.bold[p.iconId]) : themeGet(ruleBuilderWrapperAppearanceObject.default[p.iconId]);
}, p => p.isDisabled ? themeGet('colors.icon.disabled') : themeGet('colors.icon.inverse'), sx);
const RuleBuilderIcon = ({
  iconId,
  id,
  testId,
  isBold = false,
  size = 'default',
  ariaLabel = iconId,
  isDisabled,
  ...props
}) => {
  const Component = ruleBuilderIconsMap[iconId];
  return /*#__PURE__*/React__default.createElement(Wrapper, _extends({
    as: "div",
    iconId: iconId,
    size: size,
    isBold: isBold,
    isDisabled: isDisabled,
    "data-testid": testId && `${testId}-wrapper`
    // since the icon is purely decorative, we place the aria-label on the wrapper element, not the svg, and we set aria-hidden to true on the svg
    // see: "eye-candy" --> https://www.w3.org/WAI/tutorials/images/decorative/
    // and: https://css-tricks.com/accessible-svg-icons/
    ,
    "aria-label": ariaLabel
  }, props), /*#__PURE__*/React__default.createElement(VisuallyHidden, null, iconId), /*#__PURE__*/React__default.createElement(Component, {
    size: sizeObject[size],
    "data-testid": testId && `${testId}-icon`,
    "aria-hidden": "true"
  }));
};
RuleBuilderIcon.displayName = "RuleBuilderIcon";
var RuleBuilderIcon$1 = RuleBuilderIcon;

export { RuleBuilderIcon$1 as default, ruleBuilderIconsMap, ruleBuilderWrapperAppearanceObject };
